import { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { cn } from '../../utils/cn'

// Sample product data - replace with actual products
const products = [
  {
    id: 1,
    name: 'Rose Quartz',
    category: 'NAKHOONS',
    image: '/images/product-1.png',
    price: '$49',
  },
  {
    id: 2,
    name: 'Midnight Black',
    category: 'NAKHOONS',
    image: '/images/product-1.png',
    price: '$49',
  },
  {
    id: 3,
    name: 'Pearl White',
    category: 'NAKHOONS',
    image: '/images/product-1.png',
    price: '$49',
  },
  {
    id: 4,
    name: 'Golden Hour',
    category: 'NAKHOONS',
    image: '/images/product-1.png',
    price: '$59',
  },
]

function ProductCard({ product, index }) {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageError, setImageError] = useState(false)

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
    >
      <Link to={`/product/${product.id}`} className="group block cursor-pointer">
        {/* Image Container */}
        <div className="relative aspect-square bg-bg-tertiary mb-4 overflow-hidden">
          {/* Fallback placeholder - only visible if image fails */}
          {imageError && (
            <div className="absolute inset-0 flex items-center justify-center bg-bg-tertiary">
              <span className="text-text-muted text-sm">Product Image</span>
            </div>
          )}

          {/* Product Image */}
          {!imageError && (
            <img
              src={product.image}
              alt={product.name}
              className={cn(
                "absolute inset-0 w-full h-full object-cover object-center transition-all duration-500",
                "group-hover:scale-105",
                imageLoaded ? "opacity-100" : "opacity-0"
              )}
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageError(true)}
            />
          )}

          {/* Loading state */}
          {!imageLoaded && !imageError && (
            <div className="absolute inset-0 flex items-center justify-center bg-bg-tertiary">
              <div className="w-6 h-6 border-2 border-text-muted/30 border-t-text-muted rounded-full animate-spin" />
            </div>
          )}
        </div>

        {/* Product Info */}
        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.15em] text-text-muted mb-1">
            {product.category}
          </p>
          <h3 className="text-sm font-medium text-text-primary uppercase tracking-wider group-hover:text-text-secondary transition-colors">
            {product.name}
          </h3>
          <p className="text-sm text-text-secondary mt-1">{product.price}</p>
        </div>
      </Link>
    </motion.div>
  )
}

export default function ProductShowcase() {
  return (
    <section id="products" className="py-20 lg:py-32 bg-bg-primary">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-text-secondary mb-4">
            Our Collections
          </h2>
          <p className="text-2xl font-serif text-text-primary">
            Smart Nails for Every Occasion
          </p>
        </motion.div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-12">
          {products.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </div>

        {/* View All Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <a
            href="#collections"
            className={cn(
              'inline-flex items-center justify-center',
              'px-8 py-4',
              'bg-primary text-white',
              'text-sm font-medium uppercase tracking-wider',
              'hover:bg-primary-light transition-colors duration-300'
            )}
          >
            All Collections
          </a>
        </motion.div>
      </div>
    </section>
  )
}
